export const START_CHATING = 'START_CHATING';
export const SENT_MSG = 'SENT_MSG';
export const SET_USER = 'SET_USER';
export const REPLY_MSG = 'REPLY_MSG';
export const GROUP_MSG = 'GROUP_MSG';
export const CONTACT_MSG = 'CONTACT_MSG';